export const SEND_SMS_API_URL = "/api/v3/downloads/sms_link";
